import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ade7176"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "is-flex number-input-wrap" }
const _hoisted_2 = ["value", "min", "max", "data-int"]

import BulmaButtonIcon from "@/components/common/BulmaButtonIcon.vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'BulmaNumberInput',
  props: {
  min: {
    type: Number,
    default: 0
  },
  max: {
    type: Number,
    default: 999999
  },
  value: {
    type: Number,
    default: 0
  },
  dataInt: {
    type: String,
    default: ""
  }
},
  emits: ['input'],
  setup(__props, { emit: __emit }) {

const props = __props

const emits = __emit

function updateValue(e: Event) {
  const { value }  = e.target as HTMLInputElement
  const numValue = Number(value)
  const isValidUpdate = (numValue !== props.value)
    && (numValue >= props.min)
    && (numValue <= props.max)

  if (isValidUpdate) {
    emits('input', numValue)
  }
}

function incrementValue() {
  emits('input', Math.min(props.value + 1, props.max))
}

function decrementValue() {
  emits('input', Math.max(props.value - 1, props.min))
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BulmaButtonIcon, {
      iconClass: "fa fa-minus",
      stylingClass: "no-border-radius-right",
      onClick: decrementValue
    }),
    _createElementVNode("input", {
      value: __props.value,
      min: __props.min,
      max: __props.max,
      "data-int": __props.dataInt,
      class: "input center-text number-input no-border-radius",
      type: "number",
      onInput: updateValue
    }, null, 40, _hoisted_2),
    _createVNode(BulmaButtonIcon, {
      iconClass: "fa fa-plus",
      stylingClass: "no-border-radius",
      onClick: incrementValue
    })
  ]))
}
}

})